export default "__VITE_ASSET__DtNEdH3V__"